import angular from "angular";
import { languages } from "../../language/languages";
import { BuilderViewConfig } from "./BuilderViewConfigInfo";

function AppConfiguration($translateProider: angular.translate.ITranslateProvider) {
    for (let i in BuilderViewConfig.SUPPORT_LANGUAGE) {
        if (Object.hasOwnProperty.call(BuilderViewConfig.SUPPORT_LANGUAGE, i)) {
            let lan = BuilderViewConfig.SUPPORT_LANGUAGE[i];
            let lanConfig = languages[lan];

            var dict = {};
            for (let j in lanConfig) {
                angular.extend(dict, lanConfig[j]);
            }

            // lan-语言种类 dict-语言字典
            $translateProider.translations(lan, dict);
        }
    }
    $translateProider
        .preferredLanguage(BuilderViewConfig.DEFAULT_LANGUAGE)
        .fallbackLanguage(BuilderViewConfig.SUPPORT_LANGUAGE)
        .useSanitizeValueStrategy('sceParameters');
}

const injector = ["$translateProvider", AppConfiguration];

export { injector };